// @flow

import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import Styles from "./CSFTitle.module.scss";

const CSFTitle = () => {
  const { t } = useTranslation("offerPageDetail");
  return (
    <div className={Styles.wrapper}>
      <div className={classnames(Styles.greenArrow, "theme-bgcolor-primary")} />
      <div className={Styles.contentWrapper}>
        <h4 className={Styles.title}>{t("changeServiceFormTitle")}</h4>
      </div>
    </div>
  );
};

export default CSFTitle;
